import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { loadGuidesByCategory } from '../../utils/cmsContentLoader';
import { Seo } from '../shared';
import KnowledgeHubLayout from '../explore/KnowledgeHubLayout';
import DiscoverySection from '../explore/DiscoverySection';
import KnowledgeFlow from '../explore/KnowledgeFlow';
import { LIVING_HUB } from '../../data/livingInNepalKnowledge';
import { LAST_VERIFIED } from '../../data/officialSources';
import '../../styles/explore.scss';
import '../../styles/guides.scss';

function LivingInNepalHubPage() {
	const [guides, setGuides] = useState([]);
	const hub = LIVING_HUB;

	useEffect(() => {
		loadGuidesByCategory('living_in_nepal').then(setGuides);
	}, []);

	return (
		<KnowledgeHubLayout
			seo={<Seo title="Living in Nepal — SIM, Money, Apps & Etiquette" path="/living-in-nepal" description="Complete day-to-day guide for travelers in Nepal — SIM cards, ATMs, apps, cultural etiquette, electricity, and connectivity." />}
			hero={{ image: hub.hero, eyebrow: hub.eyebrow, title: hub.title, lead: hub.lead }}
			quickFacts={hub.quickFacts}
			intro={{ title: 'Day-to-day in Nepal', text: 'Stop feeling like a confused outsider by day two.', body: 'This hub covers everything after you land — the practical knowledge government websites never publish.' }}
			faqs={hub.faqs}
			related={hub.related}
			cta={{ title: 'Settled in?', text: 'Explore destinations or plan your trek.', to: '/destinations', label: 'Explore Nepal' }}
		>
			<KnowledgeFlow title="Setup journey" steps={[
				{ label: 'Arrival', to: '/arrival', desc: 'Land at TIA' },
				{ label: 'SIM', to: '/plan/sim', desc: 'Get connected' },
				{ label: 'Money', to: '/plan/atm', desc: 'Withdraw NPR' },
				{ label: 'Living', to: '/living-in-nepal', desc: 'You are here' },
				{ label: 'Explore', to: '/destinations', desc: 'Go see Nepal' },
			]} />
			<DiscoverySection eyebrow="Every question" title="Day-to-day guide">
				{hub.sections.map((s, i) => (
					<div key={s.id} className="info-card arrival-step-card" style={{ marginBottom: '1.25rem' }}>
						<div className="info-card__body">
							<span className="arrival-step-card__num">Section {i + 1}</span>
							<h3 className="info-card__title">{s.question}</h3>
							<p className="info-card__text">{s.answer}</p>
							{s.tips && <div className="arrival-tips"><p className="arrival-tips__label">Traveler tips</p><ul>{s.tips.map((t) => <li key={t}>{t}</li>)}</ul></div>}
							{s.source && <p className="section-source-tag">Official: <a href={s.source.url} target="_blank" rel="noopener noreferrer">{s.source.name}</a></p>}
						</div>
					</div>
				))}
			</DiscoverySection>
			<DiscoverySection eyebrow="Detailed guides" title="In-depth articles" alt>
				<div className="guide-grid">
					{guides.map((g) => (
						<Link key={g.slug} to={`/guides/${g.slug}`} className="guide-card">
							<h3 className="guide-card__title">{g.title}</h3>
							{g.summary && <p className="guide-card__summary">{g.summary}</p>}
						</Link>
					))}
				</div>
			</DiscoverySection>
			<p className="section-source-tag container" style={{ marginTop: '1rem' }}>Last verified: {LAST_VERIFIED}</p>
		</KnowledgeHubLayout>
	);
}

export default LivingInNepalHubPage;
